import { Auth } from "aws-amplify";
import { stringify as urlStringify } from 'query-string';
import { HttpClientError } from '../../exception';
import config from "../../config";
import { loadAccessKey } from "../../services/auth/on-prem-auth-service";
import { signOutAndRedirectToLogin } from "../../services/auth/auth-service";
import { applyImpersonation, isImpersonating } from "../../services/auth/impersonation-service";

const IMPERSONATION_READ_ONLY_MESSAGE = 'Not available in a read-only support session';

async function setAuthToken(headers, url) {
  try {
    if (config.IS_ON_PREM) {
      headers['Authorization'] = loadAccessKey();
    } else {
      const accessToken = (await Auth.currentSession()).getAccessToken();
      // unchanged unless a support impersonation session is active
      headers['Authorization'] = applyImpersonation(accessToken.getJwtToken(), url, accessToken.payload?.username);
    }

  } catch (err) { }
}

async function fetchCall(url, config) {
  try {
    // default headers
    const commonHeaders = {
      'Content-Type': 'application/json',
    };
    config.headers = Object.assign(commonHeaders, config.headers);
    await setAuthToken(config.headers, url);

    const fetchResponse = await fetch(url, config);
    const response = await fetchResponse.json();
    const status = fetchResponse.status;

    if (status >= 200 && status < 300) {
      // if success
      return { response, status };
    } if (status === 403 && isImpersonating()) {
      // the authorizer refused a write (or a sensitive read) in a read-only support session
      return { response: IMPERSONATION_READ_ONLY_MESSAGE, status };
    } if (status >= 401 && status < 403) {
      // unauthorized
      await signOutAndRedirectToLogin();
      return { response, status };
    } else {
      // if error response
      return { response: response.message, status: response.code };
    }
  } catch (err) {
    // client error
    throw new HttpClientError(err)
  }
}

export async function get(url, params = {}, headers = {}) {
  const urlParams = urlStringify(params);
  let preparedUrl = (url || '').replace(/[?&]+$/, '');
  if (urlParams) {
    const separator = preparedUrl.includes('?') ? '&' : '?';
    preparedUrl = `${preparedUrl}${separator}${urlParams}`;
  }
  return await fetchCall(preparedUrl, { headers });
}

export async function post(url, data, headers = {}) {
  return await fetchCall(url, {
    method: 'POST',
    body: JSON.stringify(data),
    headers,
  });
}

export async function put(url, data, headers = {}) {
  return await fetchCall(url, {
    method: 'PUT',
    body: JSON.stringify(data),
    headers,
  });
}

export async function del(url, headers = {}) {
  return await fetchCall(url, {
    method: 'DELETE',
    headers,
  });
}
